export default __webpack_public_path__ + "static/media/Domo.0c67521a.png";